import { Collapse, DisplayInfo, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import SectionShowSchedule from '../../../SectionsMaintainer/parts/SectionShowSchedule';
import { useNonStructuredSectionSchedulesLoader } from '../hooks/NonStructuredSectionSchedulesLoader';
import SectionScheduleForm from './SectionScheduleForm';

const SectionSchedulesTab = () => {
  const { t } = useTranslation();
  const prefix = 'sectionsMaintainer.update';
  const { result, refresh } = useNonStructuredSectionSchedulesLoader();
  const data = result?.success ? result.data : null;

  const options = useMemo(() => {
    if (!data) {
      return {
        scheduleModules: [],
        scheduleLegends: [],
      };
    }

    return {
      scheduleModules: data.timeModules,
      scheduleLegends: data.activities,
    };
  }, [data]);

  if (!data) {
    return <></>;
  }

  if (!data?.isScheduleRequired) {
    return (
      <Row className="mt-4">
        <Col
          xs={12}
          className="d-flex justify-content-center align-items-center"
        >
          <DisplayInfo
            title={t(`sectionsMaintainer.noScheduleRequired.title`)}
            textBody={t(`sectionsMaintainer.noScheduleRequired.description`)}
          />
        </Col>
      </Row>
    );
  }

  return (
    <Row className="mt-4">
      <Col xs={12}>
        <div
          className="d-flex justify-content-between align-items-center bg-primary text-white px-4 py-3"
          style={{
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          <span className="fw-bold">{t(`${prefix}.concept`)}</span>
          <span className="fs-14">{t(`${prefix}.seeMore`)}</span>
        </div>

        <Collapse
          renderTitle={() => (
            <p className="fs-14 fw-600 my-auto ml-1 text-dark">
              {t(`${prefix}.classes`)}
            </p>
          )}
          headerStyles={{
            backgroundColor: '#fff',
            height: 60,
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
          }}
          contentClassName="pt-3 border-left border-right border-bottom border-light"
          renderBtn={({ isOpened, toggle }) => (
            <div onClick={toggle} className="cursor-pointer mr-3">
              <Icon name={isOpened ? 'chevron_up' : 'chevron_right'} />
            </div>
          )}
        >
          <SectionScheduleForm data={data} onSave={refresh} />
        </Collapse>

        <Collapse
          renderTitle={() => (
            <p className="fs-14 fw-600 my-auto ml-1 text-dark">
              {t(`${prefix}.schedule`)}
            </p>
          )}
          headerStyles={{
            backgroundColor: '#f8f9fa',
            height: 60,
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
          contentClassName="pt-3 border-left border-right border-bottom border-light"
          renderBtn={({ isOpened, toggle }) => (
            <div onClick={toggle} className="cursor-pointer mr-3">
              <Icon name={isOpened ? 'chevron_up' : 'chevron_right'} />
            </div>
          )}
        >
          <SectionShowSchedule
            section={data.section}
            sectionSchedules={data.section.sectionSchedules.filter(
              (schedule) => !schedule.deletedAt,
            )}
            modules={options.scheduleModules}
            legends={options.scheduleLegends}
          />
        </Collapse>
      </Col>
    </Row>
  );
};

export default SectionSchedulesTab;
